import React from "react";
import { useOutletContext } from "react-router-dom";

const CurrentProtection = () => {
  const { statusData } = useOutletContext();
  const E1 = statusData?.E1;

  return (
    <div className="overflow-x-auto mt-3 mb-5 px-1">
      <table className="table table-compact w-full">
        <thead className="text-white">
          <tr>
            <th className="bg-primary text-xs md:text-base">Project</th>
            <th className="bg-primary text-xs md:text-base">Machine</th>
            <th className="bg-primary text-xs md:text-base">Setting</th>
            <th className="bg-primary text-xs md:text-base">Action</th>
          </tr>
        </thead>
        <tbody>
          {/* row 1 --------------------------------------------- */}
          <tr>
            <td className="w-48 md:w-80">
              <h3 className="md:text-base font-medium whitespace-normal">
                Discharge Over Current Protection
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">{E1?.dischargeOCP}</h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/* ------------------------------------------------------- */}

          {/* row 2 --------------------------------------------- */}
          <tr>
            <td className="w-48 md:w-80">
              <h3 className="md:text-base font-medium whitespace-normal">
                Over Current Delay Of Discharge
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E1?.dischargeOCRT}
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/* ------------------------------------------------------- */}

          {/* row 3 --------------------------------------------- */}
          <tr>
            <td className="w-48 md:w-80">
              <h3 className="md:text-base font-medium whitespace-normal">
                Charge Over Current Protection
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">{E1?.chargeOCP}</h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/* ------------------------------------------------------- */}

          {/* row 3 --------------------------------------------- */}
          <tr>
            <td className="w-48 md:w-80">
              <h3 className="md:text-base font-medium whitespace-normal">
                Charge Over Current Delay
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">{E1?.chargeOCRT}</h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
            <td className="w-36">
              <button className="btn btn-primary btn-xs md:btn-sm w-36">
                Set
              </button>
            </td>
          </tr>
          {/* ------------------------------------------------------- */}
        </tbody>
      </table>
    </div>
  );
};

export default CurrentProtection;
